module.exports = __webpack_public_path__ + "img/icon-campanha-rejeitada.b213312b.svg";